import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotList from "./components/HotList";
import ContrastSection from "./components/ContrastSection";
import TimelineSection from "./components/TimelineSection";
import FaqSection from "./components/FaqSection";
import AboutSection from "./components/AboutSection";
import ContactSection from "./components/ContactSection";
import FooterSection from "./components/FooterSection";
import { faqs } from "@/mocks/chiGuaData";

function FaqSchema() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 700);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <FaqSchema />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <Hero />
          <HotList />
          <ContrastSection />
          <TimelineSection />
          <FaqSection />
          <AboutSection />
          <ContactSection />
        </main>
        <FooterSection />

        {showTop && (
          <a
            href="#top"
            aria-label="返回顶部"
            className="fixed bottom-6 right-5 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-foreground-950 text-background-50 shadow-none transition-colors hover:bg-primary-600"
          >
            <i className="ri-arrow-up-line text-lg" />
          </a>
        )}
      </div>
    </>
  );
}